import Ably from 'ably'
import RecessAPI from '@services/RecessAPI'
import RecessRT from '@services/RecessRT'

class RTService

  @mixin: (events = []) ->

    created: ->
      @subscribeEvents events

    beforeDestroy: ->
      @unsubscribeEvents events

    computed:
      memberChannel: ->
        @channelFor "app:#{RecessAPI.memberToken}"
    methods:
      subscribeEvents: ->
        for event in events
          @subscribe event, @[@callbackNameForEvent(event)]

      unsubscribeEvents: ->
        for event in events
          @unsubscribe event, @[@callbackNameForEvent(event)]

      subscribe: (event, callback) ->
        @memberChannel.subscribe event, callback

      unsubscribe: (event, callback) ->
        @memberChannel.unsubscribe event, callback

      once: (event, callback) ->
        @memberChannel.once event, callback

      channelFor: (name) ->
        RecessRT.ably.channels.get "ui-stream:#{name}"

      callbackNameForEvent: (event) ->
        @handlerNameFor event

export default RTService